
export default function useRequiredFieldsFilled(values) {
  if (!values) {
    return false;
  }
  if (!values.name) {
    return false;
  }
  return true;
};
